// Monetização do Investidor Comum.
// Google AdSense: preencha REACT_APP_ADSENSE_CLIENT e os slots no frontend/.env
// (client no formato ca-pub-XXXXXXXXXXXXXXXX). Sem ID, os blocos exibem um
// placeholder elegante e nada quebra.
// Links de afiliados e produtos patrocinados: troque as URLs abaixo pelas suas
// URLs de afiliado/contratos. Todo link sai com rel="sponsored".

export const ADSENSE = {
    client: (process.env.REACT_APP_ADSENSE_CLIENT || "").trim(),
    slots: {
        leaderboard: (process.env.REACT_APP_ADSENSE_SLOT_LEADERBOARD || "").trim(),
        inFeed: (process.env.REACT_APP_ADSENSE_SLOT_INFEED || "").trim(),
        inArticle: (process.env.REACT_APP_ADSENSE_SLOT_INARTICLE || "").trim(),
    },
};

export const SPONSORED_PRODUCTS = [
    {
        name: "Cartão Gold Sem Anuidade",
        partner: "Banco Parceiro",
        description: "Cashback de 1% em todas as compras, sem anuidade e sem tarifas escondidas.",
        cta: "Solicitar cartão",
        url: "https://investidorcomum.com.br/indica/cartao-gold",
    },
    {
        name: "Corretora Zero Corretagem",
        partner: "Corretora Parceira",
        description: "Ações e FIIs com corretagem zero, app completo e atendimento em português.",
        cta: "Abrir conta grátis",
        url: "https://investidorcomum.com.br/indica/corretora-zero",
    },
    {
        name: "Seguro de Vida Acessível",
        partner: "Seguradora Parceira",
        description: "Proteção familiar a partir de R$ 9/mês, contratação 100% digital em 5 minutos.",
        cta: "Fazer simulação",
        url: "https://investidorcomum.com.br/indica/seguro-vida",
    },
];

export const AFFILIATE_TOOLS = [
    {
        name: "Planilha de Orçamento 50/30/20",
        description: "A planilha exata do nosso método, pronta para usar no Google Sheets.",
        url: "https://investidorcomum.com.br/indica/planilha-orcamento",
        tag: "Grátis",
    },
    {
        name: "Curso Primeiros Investimentos",
        description: "Do zero à primeira compra de título público em 4 horas de aula.",
        url: "https://investidorcomum.com.br/indica/curso-iniciante",
        tag: "Recomendado",
    },
    {
        name: "Comparador de Corretoras",
        description: "Compare taxas, custódia e rentabilidade das principais corretoras do Brasil.",
        url: "https://investidorcomum.com.br/indica/comparador",
        tag: "Ferramenta",
    },
    {
        name: "Calculadora de Independência Financeira",
        description: "Descubra em quanto tempo você pode viver de renda com a regra dos 4%.",
        url: "https://investidorcomum.com.br/indica/calculadora-if",
        tag: "Ferramenta",
    },
];
